var _if = {exports: {}};

export { _if as _ };
